module.exports = __webpack_public_path__ + "../resources/img/ic_re_home_energy_wh.09d6d352.svg";